import { TeamMember } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamApi } from '../api';
import { TEAM_DAY_QUERY_KEY, TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface RemoveTeamMemberParams {
  teamId: string;
  memberUserId: string;
}

export const useRemoveTeamMember = () => {
  const queryClient = useQueryClient();

  const removeTeamMemberMutation = useMutation({
    mutationFn: ({ teamId, memberUserId }: RemoveTeamMemberParams) => {
      return teamApi
        .removeTeamMember(teamId, memberUserId)
        .then(({ data }) => data.membership as TeamMember);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DAY_QUERY_KEY });
    },
  });

  return {
    removeTeamMember: removeTeamMemberMutation.mutateAsync,
    isRemovingTeamMember: removeTeamMemberMutation.isPending,
    ...removeTeamMemberMutation,
  };
};
